<template>
    <div>
        <vue-ueditor-wrap editor-id="ueditor" v-model="contents" :config="uEditorConfig" @before-init="beforeInit"></vue-ueditor-wrap>
        <input
                @change="selectedFile"
                style="visibility: hidden; height: 0; position: absolute"
                type="file"
                :accept="acceptType"
                name
                id="inputFile"
        />
    </div>
</template>

<script>
  export default {
    name:'UEditor',
    props: {
      content: ''
    },
    data() {
      return {
        contents: this.contents,
        uEditorConfig: {
          autoHeightEnabled: false, // 编辑器不自动被内容撑高
          initialFrameHeight: window.innerHeight - 500, // 初始容器高度
          initialFrameWidth: '100%', // 初始容器宽度
        },
        acceptType: '',
        editorHandler: null,
      }
    },
    methods: {
      // 资源加载完毕
      beforeInit() {
        this.ueditor = UE;
        this.initUeditor();
      },
      // 二次开发，自定义按钮
      initUeditor() {
        let ueditor = this.ueditor;
        let that = this;

        ueditor.registerUI(
          "selectimage", // 按钮名称
          function (editor, uiName) {
            //注册按钮执行时的command命令，使用命令默认就会带有回退操作
            editor.registerCommand(uiName, {
              execCommand: function () {
                //   alert("execCommand:" + uiName);
                that.editorHandler = editor
              },
            });
            //创建一个button
            var btn = new UE.ui.Button({
              //按钮的名字
              name: uiName,
              //提示
              title: "选择图片",
              //添加额外样式,指定icon图标,这里默认使用一个重复的icon
              cssRules: "background-position: -380px 0;",
              //点击时执行的命令
              onclick: function () {
                //这里可以不用执行命令,做你自己的操作也可
                editor.execCommand(uiName);
                that.acceptType = "image/*";
                that.uploadType = 0;
                setTimeout(function () {
                  that.handleOpenFile();
                }, 1);
              },
            });

            //当点到编辑内容上时，按钮要做的状态反射
            editor.addListener("selectionchange", function () {
              var state = editor.queryCommandState(uiName);
              if (state == -1) {
                btn.setDisabled(true);
                btn.setChecked(false);
              } else {
                btn.setDisabled(false);
                btn.setChecked(state);
              }
            });
            //因为你是添加button,所以需要返回这个button
            return btn;
          },
          19, // 放置在toolbar的位置
          ["ueditor"]
        );
      },
      // 打开文件
      handleOpenFile() {
        let input = document.getElementById("inputFile");
        // 解决同一个文件不能监听的问题
        input.addEventListener(
          "click",
          function () {
            this.value = "";
          },
          false
        );
        // 点击input
        input.click();
      },
      // 选择好文件
      selectedFile($event) {
        const file = $event.target.files[0];
        this.uploadFile(file);
      },
      uploadFile(file) {
        const formData = new FormData()
        formData.append('file', file)
        this.$axios.post("/file/upload", formData).then(res => {
          if (res.status === 200) {
            let imageHtml =  "<img src=\"" + res.data.data + "\"/>";
            this.editorHandler.execCommand('inserthtml', imageHtml);
          }
        })
      }
    }
  }

</script>
<style scoped>
</style>
